export default __webpack_public_path__ + "static/media/logo_lsteste_white.fe4d9b13.png";